/* eslint-disable react-hooks/exhaustive-deps  */
/* eslint-disable array-callback-return  */
import React, { useEffect, useState, useMemo, useRef } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Link, generatePath, useLocation } from 'react-router-dom';
import { Container } from 'app/components';
import { useRouter, useConfig } from 'app/hooks';
import { SectionInfo, SectionInfoTitle, SectionInfoContent, TableSection, ListDetail } from '../styles';
import { useSelector } from 'react-redux';

const propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      id: PropTypes.string
    }).isRequired
  }).isRequired,
  content: PropTypes.string,
  fetchContent: PropTypes.func.isRequired,
  clearPriceListState: PropTypes.func.isRequired,
  clearGastronomyState: PropTypes.func.isRequired,
  history: PropTypes.shape({
    push: PropTypes.func.isRequired
  }).isRequired,
  location: PropTypes.shape({
    pathname: PropTypes.string.isRequired
  }).isRequired
};
const defaultProps = {
  content: null
};

const PriceList = ({
  match: {
    params: { slug: cinemaName, secondarySlug: cinemaItemName }
  },
  content,
  fetchContent,
  clearPriceListState,
  clearGastronomyState,
  history: { push },
  location,
  fetchCinema
}) => {

  const selectedCinema = useSelector(state => state.cinemas.cinemas);
  // let cinemaNameView = cinemaName?.replaceAll('-', ' ')?.replace("   ", " - ");
  let cinemaNameView = cinemaName;
  const selectedId = selectedCinema?.find(item => item.cinemaUrlName === cinemaNameView);

  const { routes } = useConfig();

  const [t, i18n] = useTranslation();
  const [isDataLoaded, setIsDataLoaded] = useState(false);
  const [cinemaItemApiCalled, setCinemaItemApiCalled] = useState(false);
  const [data, setData] = useState({});
  const [onDetail, setOnDetail] = useState(false);

  const {
    location: { state }
  } = useRouter();

  const { pathname } = location;
  const splitPath = pathname.split('/');

  const search = useLocation();
  const pathActually = splitPath[2];
  const priceId = useRef(state?.priceId);

  useEffect(() => {
    if (cinemaName && cinemaItemName) {
      getCinemaItemNamePriceList()
    }
    if (cinemaName && !cinemaItemName) {
      setIsDataLoaded(false)
      getCinemaNamePriceList()
    }
  }, [cinemaName, cinemaItemName])

  const getCinemaItemNamePriceList = () => {
    const pricelist = content?.data?.[0]?.pricelist;
    const selectedItemId = pricelist?.find(item => (item.topHeadline === cinemaItemName?.replaceAll('-', ' ') || item.topHeadlineEN === cinemaItemName?.replaceAll('-', ' ')))
    const linkedPriceListID = selectedItemId?.linkedPriceListID

    const params = { 'id': linkedPriceListID, 'type': 'detail' };
    if (linkedPriceListID) {
      fetchContent(params);
      setCinemaItemApiCalled(true)
      push(generatePath(routes.priceListt.pattern, { slug: cinemaName, secondarySlug: cinemaItemName }));
    }
  }
  const getCinemaNamePriceList = () => {
    if (!selectedId?.id) return;
    fetchCinema(selectedId?.id);

    const technologyPriceList = 1;
    const params = { id: selectedId?.id, technologyPriceList, type: 'main' };
    if (pathActually === 'price-list') {
      if (selectedId?.id) {
        fetchContent(params);
      }
    }
  }

  useEffect(() => {
    getCinemaNamePriceList()
  }, [state?.cinemaId, selectedId?.id]);

  useEffect(() => {
    if (content && content?.data?.length > 0 && cinemaItemName) {
      getCinemaItemNamePriceList()
    }
  }, [content]);

  const languageContents = useMemo(
    () => ({
      headline: i18n.language === 'en' || i18n.language === 'en-US' ? 'headlineEN' : 'headline',
      headlineColumn1: i18n.language === 'en' || i18n.language === 'en-US' ? 'headlineColumn1EN' : 'headlineColumn1',
      headlineColumn2: i18n.language === 'en' || i18n.language === 'en-US' ? 'headlineColumn2EN' : 'headlineColumn2',
      headlineColumn3: i18n.language === 'en' || i18n.language === 'en-US' ? 'headlineColumn3EN' : 'headlineColumn3',
      pricelinkDescription: i18n.language === 'en' || i18n.language === 'en-US' ? 'pricelinkDescriptionEN' : 'pricelinkDescription',
      description: i18n.language === 'en' || i18n.language === 'en-US' ? 'descriptionEN' : 'description',
      topHeadline: i18n.language === 'en' || i18n.language === 'en-US' ? 'topHeadlineEN' : 'topHeadline'
    }),
    [i18n.language]
  );


  useEffect(() => {
    if (cinemaItemName && cinemaItemApiCalled)
      setTimeout(() => setIsDataLoaded(true), 500);
    else if (!cinemaItemName) {
      setTimeout(() => setIsDataLoaded(true), 500);
    }
  }, [cinemaItemApiCalled, cinemaItemName])

  useEffect(() => {
    const params = { 'id': priceId?.current, 'type': 'detail' };
    if (priceId?.current) {
      fetchContent(params)
    }

    return () => {
      clearPriceListState()
      clearGastronomyState()
    }
  }, [i18n.language && priceId?.current]);

  // useEffect(() => {
  //   window.addEventListener("popstate", (event) => {
  //     setOnDetail(false);
  //   });
  // },[])

  useEffect(() => {
    if (!state?.isGastronomy && (content && content?.data && content?.data?.length > 0)) {
      setData(content?.data?.[0]);
    }

    if (state?.isGastronomy && (content?.data?.[0]?.id === priceId?.current || onDetail)) {
      setData(content?.data?.[0]);
    }

  }, [content]);

  const setDetailPriceList = (e, id, priceLink) => {
    e.preventDefault();
    const params = { 'id': id, 'type': 'detail' };

    if (id) {
      setOnDetail(true)
      setIsDataLoaded(false)
      fetchContent(params)
    } else {
      if (priceLink?.split(":")[0]) {
        push(window.location.replace(priceLink))
      } else if (priceLink !== '') {
        push(priceLink);
      }
    }

    // if (priceLink) {
    //   window.open(priceLink, '_blank');
    // }
  }

  useEffect(() => {
    if (onDetail === true) {
      const wholeData = content?.data?.[0]?.topHeadline;
      if (wholeData?.length > 0) {
        setIsDataLoaded(true)
        push(generatePath(routes.priceListt.pattern, { slug: cinemaName, secondarySlug: wholeData }));
        localStorage.setItem('price-detail-name-id', content?.data?.[0]?.id);
      }
    }
  }, [content]);

  useEffect(() => {
    if (pathActually?.length > 0) {
      if (pathActually === "gastro-price-list") {
        let priceId = search.search.split("=")[1];
        const params = { 'id': priceId?.current || priceId, 'type': 'detail' };
        // isGastronomy
        if (priceId?.current || priceId) {
          fetchContent(params)
        }
      }
      // else {
      //     const params = { 'id': priceDetailNameId, 'type': 'detail' };
      //     fetchContent(params)
      // }
    }
  }, [pathActually]);

  return (
    <SectionInfo>
      <Container>
        {(!isDataLoaded && data && Object.keys(data)?.length > 0 && data?.pricelist?.length === 0) && (
          <SectionInfoContent>
            <h2 style={{ textAlign: 'center' }}>{t('common.coming_soon')}</h2>
          </SectionInfoContent>
        )}
        {isDataLoaded && data && Object.keys(data)?.length > 0 && data?.pricelist?.length > 0 ? (
          <>
            <SectionInfoTitle>
              {data?.technologyPriceList === true
                ? data?.[languageContents.topHeadline]
                : data?.linkedCinema?.[0]?.cinemaName}
            </SectionInfoTitle>
            <SectionInfoContent>
              <h3>{data?.[languageContents.headline]}</h3>
              <TableSection>
                <table className="price_list_table">
                  <thead>
                    <tr>
                      <th>{data?.[languageContents.headlineColumn1]}</th>
                      <th>{data?.[languageContents.headlineColumn2]}</th>
                      <th className='price-title'>{data?.[languageContents.headlineColumn3]}</th>
                    </tr>
                  </thead>
                  <tbody>
                    {data?.pricelist?.length > 0 &&
                      data?.pricelist?.map(row => (
                        <tr>
                          <td>
                            {row?.picture && <img className="logo_img" src={row?.picture} alt="pricelist-logo-image" />}
                          </td>
                          <td
                            dangerouslySetInnerHTML={{
                              __html: row?.[languageContents.description]
                            }}
                          />
                          <td className='price-cell'>
                            {(row?.pricelink?.length > 0 || row?.[languageContents.pricelinkDescription]?.length > 0) ? (
                              <>
                                <Link
                                  className="price_link"
                                  onClick={e => setDetailPriceList(e, row?.linkedPriceListID, row?.pricelink)}
                                >
                                  {row?.[languageContents.pricelinkDescription]}
                                </Link>
                                {/* <Link className="price_link" id={`send_${row?.linkedPriceListID}`} to={sendUrl} style={{ display: 'none' }}>{row?.[languageContents.pricelinkDescription]}</Link> */}
                              </>
                            ) : (
                              <p>{row?.price}</p>
                            )}
                          </td>
                        </tr>
                      ))}
                  </tbody>
                </table>
              </TableSection>
              <ListDetail>
                <p
                  className="description_html"
                  dangerouslySetInnerHTML={{ __html: data?.[languageContents.description] }}
                />
              </ListDetail>
            </SectionInfoContent>
          </>
        ) : (
          null
        )
          //  : (<Loader />)
        }
      </Container>
    </SectionInfo>
  );
};

PriceList.propTypes = propTypes;
PriceList.defaultProps = defaultProps;

export default PriceList;
